import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";
import { handleError } from "../../utils/handleError";

const initialState = {
	isLoading: true,
	error: null,
	message: null,
	LegalSettings: null,
};

const legalSlice = createSlice({
	name: "legal",
	initialState,
	reducers: {
		clearError: (state) => {
			state.error = null;
		},
		clearMessage: (state) => {
			state.message = null;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchLegalSettings.pending, (state) => {
				state.isLoading = true;
				state.error = null;
			})
			.addCase(fetchLegalSettings.fulfilled, (state, action) => {
				state.isLoading = false;
				state.LegalSettings = action.payload?.legalSettings;
				state.message = action.payload?.message || null;
			})
			.addCase(fetchLegalSettings.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.payload?.message || "Failed to load legal settings";
			})
			.addCase(updateLegalSettingContent.pending, (state) => {
				state.isLoading = true;
				state.error = null;
			})
			.addCase(updateLegalSettingContent.fulfilled, (state, action) => {
				state.isLoading = false;
				state.LegalSettings = action.payload?.legalSettings;
				state.message = action.payload?.message || null;
			})
			.addCase(updateLegalSettingContent.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.payload?.message || "Failed to update legal settings";
			})
			.addCase(removeTeamMemberById.pending, (state) => {
				state.isLoading = true;
				state.error = null;
			})
			.addCase(removeTeamMemberById.fulfilled, (state, action) => {
				state.isLoading = false;
				state.LegalSettings = action.payload?.legalSettings;
				state.message = action.payload?.message || null;
			})
			.addCase(removeTeamMemberById.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.payload?.message || "Failed to remove team member";
			})
			.addCase(updateAboutUsTeamMember.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.payload?.message || "Failed to update team member";
			})
			.addCase(updateAboutUsTeamMember.pending, (state) => {
				state.isLoading = true;
				state.error = null;
			})
			.addCase(updateAboutUsTeamMember.fulfilled, (state, action) => {
				state.isLoading = false;
				state.LegalSettings = action.payload?.legalSettings;
				state.message = action.payload?.message || null;
			})
			.addCase(updateTeamMemberVisiblity.pending, (state, action) => {
				state.isLoading = false;
				state.error = action.payload?.message || "Failed to update team member";
			})
			.addCase(updateTeamMemberVisiblity.fulfilled, (state, action) => {
				state.isLoading = false;
				state.LegalSettings = action.payload?.legalSettings;
				state.message = action.payload?.message || null;
			})
			.addCase(updateTeamMemberVisiblity.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.payload?.message || "Failed to update team member";
			})
	},
});
export const fetchLegalSettings = createAsyncThunk(
	"legal/fetchAll",
	async (_, { rejectWithValue }) => {
		try {
			const res = await axiosInstance.get("/legal/full-legal-data");
			return res.data;
		} catch (error) {
			return rejectWithValue(handleError(error));
		}
	}
);

export const updateLegalSettingContent = createAsyncThunk(
	"legal/update",
	async (data, { rejectWithValue }) => {
		try {
			const res = await axiosInstance.patch("/legal/update-legal", data);
			return res.data;
		} catch (error) {
			return rejectWithValue(handleError(error));
		}
	}
);
export const updateAboutUsTeamMember = createAsyncThunk(
	"legal/update/team-memembers",
	async (data, { rejectWithValue }) => {
		try {
			const res = await axiosInstance.put("/legal/update-legal/team", data);
			return res.data;
		} catch (error) {
			return rejectWithValue(handleError(error));
		}
	}
)
export const removeTeamMemberById = createAsyncThunk(
	"legal/update/team/remove",
	async (id, { rejectWithValue }) => {
		try {
			const res = await axiosInstance.delete(`/legal/update-legal/team/remove/${id}`);
			return res.data;
		} catch (error) {
			return rejectWithValue(handleError(error));
		}
	}
)
export const updateTeamMemberVisiblity = createAsyncThunk(
	"legal/update/team/visiblity",
	async (id, { rejectWithValue }) => {
		try {
			const res = await axiosInstance.put(`/legal/update-legal/team/visiblity/${id}`);
			return res.data;
		} catch (error) {
			return rejectWithValue(handleError(error));
		}
	}
)

export const { clearError, clearMessage } = legalSlice.actions;
export default legalSlice.reducer;
